import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { Tooltip, Type, Box } from '@nerdwallet/currency';
import { NumStepper } from '@nerdwallet/react-stepper';

import { ENTITY_NAME, MORTGAGE } from '../../../../lib/analytics-constants';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/mortgage-calculator';
import {
  MortgageInput,
  formatYears,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';

import styles from './loan-term-input.module.less';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

type onInputChange = OnChangeEvent | number;

const LoanTermInput: React.FC<MortgageInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
}) => {
  // if inputType is RANGE we need to set a default value, so taking placeholder if needed
  const placeholder = inputs?.loanTerm;
  const value = manualInputs?.loanTerm ?? placeholder;
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: onInputChange) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'loanTerm',
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'loanTerm',
      calculator: MORTGAGE,
      inputType: 'number',
    });
  };

  return (
    <Box>
      <Type size="1">
        Loan term
        <Tooltip
          placement="top"
          content="The amount of time you have to pay back the loan. Usually 15 or 30 years for common loan types."
          analytics={{
            entityName: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            eventType: ENTITY_NAME.HELP_BUBBLE_INTERACTED,
            payload: {
              additional_attributes: {
                help_button_location: 'loan_term',
              },
            },
          }}
        />
      </Type>
      <Box className={styles.numStepperWrapper}>
        <NumStepper
          editable
          formatter={formatYears}
          max={30}
          min={1}
          stepSize={1}
          value={value}
          onChange={onInputChange}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanTermInput);
